import { render, staticRenderFns } from "./productDelBanner.vue?vue&type=template&id=57d069f2&scoped=true&"
import script from "./productDelBanner.vue?vue&type=script&lang=js&"
export * from "./productDelBanner.vue?vue&type=script&lang=js&"
import style1 from "./productDelBanner.vue?vue&type=style&index=1&id=57d069f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d069f2",
  null
  
)

export default component.exports